var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95830_36176)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14286 3C1.57454 3 1.02949 3.22576 0.627628 3.62763C0.225765 4.02949 0 4.57454 0 5.14286L0 6.48571H20V5.14286C20 4.57454 19.7742 4.02949 19.3724 3.62763C18.9705 3.22576 18.4255 3 17.8571 3H2.14286ZM0 15.8571V8.27143H20V15.8571C20 16.1385 19.9446 16.4172 19.8369 16.6772C19.7292 16.9372 19.5714 17.1734 19.3724 17.3724C19.1734 17.5714 18.9372 17.7292 18.6772 17.8369C18.4172 17.9446 18.1385 18 17.8571 18H2.14286C1.57454 18 1.02949 17.7742 0.627628 17.3724C0.225765 16.9705 0 16.4255 0 15.8571ZM13.5714 12.8214C13.3346 12.8214 13.1075 12.9155 12.9401 13.0829C12.7726 13.2504 12.6786 13.4775 12.6786 13.7143C12.6786 13.9511 12.7726 14.1782 12.9401 14.3456C13.1075 14.5131 13.3346 14.6071 13.5714 14.6071H15.7143C15.9511 14.6071 16.1782 14.5131 16.3456 14.3456C16.5131 14.1782 16.6071 13.9511 16.6071 13.7143C16.6071 13.4775 16.5131 13.2504 16.3456 13.0829C16.1782 12.9155 15.9511 12.8214 15.7143 12.8214H13.5714Z",
    fill: "#6E7177"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95830_36176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.4a9dedbfc87b16cc8d6d9ea428458a76.svg";
export { ForwardRef as ReactComponent };